import { Task, CompleteTaskPayload } from "~/types/task";
import { baseService } from "../base";
import { PaginationResponse } from "../type";
import { CreateDispatchNoteParams, CreateNoteParams, GetTaskParams } from "./task.types";

export const taskService = {
  getTasks: async (params: GetTaskParams) => {
    const { data } = await baseService.get<PaginationResponse<Task>>("/task", {
      params,
    });
    return data;
  },
  getTask: async (taskId: string) => {
    const { data } = await baseService.get<Task>(`/task/${taskId}`);
    return data;
  },
  getMostUrgentTasks: async () => {
    const { data } = await baseService.get<Task[]>(
      `/task/urgent`
    );
    return data;
  },
  createTask: async (payload: FormData) => {
    const { data } = await baseService.post("/task", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  updateTask: async ({
    taskId,
    payload,
  }: {
    taskId: string;
    payload: FormData;
  }) => {
    const { data } = await baseService.patch(`/task/${taskId}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  createNote: async (body: CreateNoteParams) => {
    const { data } = await baseService.post("/notes", body);
    return data;
  },
  deleteTask: async (taskId: string) => {
    const { data } = await baseService.delete(`/task/${taskId}`);
    return data;
  },
  completeTask: async (taskId: string, payload: CompleteTaskPayload) => {
    const { data } = await baseService.patch<Task>(
      `/task/${taskId}/complete`,
      payload
    );
    return data;
  },
  getTasksForDate: async (startDate: string, endDate: string) => {
    const { data } = await baseService.get<Task[]>("/task/by-date", {
      params: { startDate, endDate },
    });
    return data;
  },
  createDispatchNote: async (params: CreateDispatchNoteParams) => {
    const formData = new FormData();
    formData.append("title", params.title);
    formData.append("date", params.date);
    if (params.description) {
      formData.append("description", params.description);
    }
    if (params.files?.length) {
      params.files.forEach((file) => {
        formData.append("files", file);
      });
    }
    if (params.staffIds?.length) {
      params.staffIds.forEach((id) => {
        formData.append("staffIds[]", id);
      });
    }
    const { data } = await baseService.post<Task>(
      "/task/dispatch-note",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return data;
  },
};
